import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { PushQuizzStyle } from './../../styles'
import Router from './../../services/Router'
import { GetMonth } from './../../helpers/date'

class PushQuizz extends Component {

  render() {
    const {picture} = this.props
    const {date_start, date_end, enabled, alreadyPlayed, current} = this.props.menu.challenge.quiz
    console.log(this.props)
    return (
      <div className={`push-quizz ${PushQuizzStyle()}`}>
        <div className="push-quizz-inner">
          <h3>Challenge Yourself</h3>
          <p>{date_start.substring(3,5)}th of {GetMonth(date_start.substring(0,2))} to {date_end.substring(3,5)}th of {GetMonth(date_end.substring(0,2))}</p>

          <Link to={ Router.currentQuizz.path } className='btn btn-white'> Start the quizz </Link>

          {/* { enabled && !current && <Link to={ Router.currentQuizz.path } className='btn btn-white'> Start the quizz </Link> } */}

          <Link to={ Router.hubQuizz.path } className='link'> See previous quizzes </Link>
        </div>
      </div>
    )
  }
}

export default connect(
  ({ Session }) => ({
    menu: Session.menu,
  })
)(PushQuizz)


// WEBPACK FOOTER //
// ./src/components/Challenge/PushQuizz.js